export default __webpack_public_path__ + "c87e4a14bf235a604b0a815c34886906.png";